import React from "react";
import styled from "styled-components";
import { FiPhoneCall, FiMapPin, FiMail } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import HowItWorks from "./HowItWorks";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

export default function Contact() {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>Contact Us | Maids Service Pakistan</title>
        <meta
          name="description"
          content="Contact Maids Service Pakistan to book a maid or inquire about our flexible cleaning plans. Available across Pakistan."
        />
      </Helmet>

      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Wrapper id="contact">
          <Container>
            <LeftSection>
              <h2>Send Email Us At</h2>
              <Underline />
              <form>
                <Row>
                  <Select>
                    <option>Need Services</option>
                    <option>Register As Worker</option>
                  </Select>
                  <Input type="text" placeholder="Your Name *" required />
                </Row>
                <Row>
                  <Input type="email" placeholder="Your Mail *" required />
                  <Input type="tel" placeholder="Phone Number" />
                </Row>
                <Textarea placeholder="Message *" required />
                <Button type="submit">Send Email</Button>
              </form>
            </LeftSection>

            <RightSection>
              <h2>Contact Details</h2>
              <Underline />
              <ContactInfo>
                <IconBox>
                  <FiPhoneCall />
                </IconBox>
                <div>
                  <strong>Call Us:</strong>
                  <p>+923350006269</p>
                </div>
              </ContactInfo>
              <ContactInfo>
                <IconBox>
                  <FaWhatsapp />
                </IconBox>
                <div>
                  <strong>Call Us:</strong>
                  <p>+923350006269</p>
                </div>
              </ContactInfo>
              <ContactInfo>
                <IconBox>
                  <FiMail />
                </IconBox>
                <div>
                  <strong>Email:</strong>
                  <p>info@maidservice.com</p>
                </div>
              </ContactInfo>
              <ContactInfo>
                <IconBox>
                  <FiMapPin />
                </IconBox>
                <div>
                  <strong>Address:</strong>
                  <p>
                    Shop: 3, Plot: 41c, Street: 3, Khalid Commercial DHA phase
                    7 ext, Karachi
                  </p>
                </div>
              </ContactInfo>
            </RightSection>
          </Container>
        </Wrapper>
        {location.pathname === "/contact" ? <HowItWorks /> : null}
      </motion.div>
    </>
  );
}

const Wrapper = styled.section`
  padding: 60px 20px;
  background: #fff;
  margin-top: 5%;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
`;

const Underline = styled.div`
  width: 50px;
  height: 4px;
  background-color: #f97316;
  margin: 10px 0 30px 0;
`;

const LeftSection = styled.div`
  flex: 1;
  min-width: 300px;

  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

const RightSection = styled.div`
  flex: 1;
  min-width: 300px;
`;

const Row = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
`;

const Select = styled.select`
  flex: 1;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
`;

const Textarea = styled.textarea`
  padding: 12px;
  height: 120px;
  border: 1px solid #ccc;
  border-radius: 6px;
  resize: none;
`;

const Button = styled.button`
  background-color: #1c1c1c;
  color: white;
  padding: 15px;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #111;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 30px;

  strong {
    font-weight: bold;
  }

  p {
    margin: 5px 0 0;
    color: #2fb8a7;
  }
`;

const IconBox = styled.div`
  background-color: #2fb8a7;
  color: white;
  padding: 15px;
  border-radius: 4px;
  font-size: 20px;
`;
